// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveProgramAdvisoryBoardHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ProgramAdvisoryBoardMemberDTO from '../models/ProgramAdvisoryBoardMemberDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    member: ProgramAdvisoryBoardMemberDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            member: null,
        },
        initValues);
    },
    member: 'member',
}

interface Result extends ResultDTO {
    member: ProgramAdvisoryBoardMemberDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            member: null,
        },
        initValues);
    },
    member: 'member',
}

export { Request, Result };